import arrowDown from "./arrow-down.svg";
import arrowRight from "./arrow-right.svg";
import chat from "./chat.svg";
import conferences from "./conferences.svg";
import dashboard from "./dashboard.svg";
import debug from "./debug.svg";
import eye from "./eye-icon.svg";
import file from "./file-icon.svg";
import globe from "./globe.svg";
import home from "./home-icon.svg";
import honorarium from "./honorarium-icon.svg";
import logo from "./logo-liberty-fund.svg";
import magnifyingGlass from "./magnifying-glass.svg";
import observe from "./observe-icon.svg";
import pdf from "./pdf-icon.svg";
import referral from "./referral-icon.svg";
import facebook from "./social-facebook.svg";
import instagram from "./social-instagram.svg";
import twitter from "./social-twitter.svg";
import tax from "./tax-icon.svg";
import trash from "./trash-icon.svg";
import warning from "./warning-icon.svg";

/* hero icon passthru */
import {
  ArrowTopRightOnSquareIcon as ExternalLinkIcon,
  PhoneArrowUpRightIcon,
  PrinterIcon,
} from "@heroicons/react/20/solid";

/**
 * Vite resolves an SVG import to its URL string, whereas Next.js resolved it to
 * a static-image object. Call sites read `.src`, so the URL is wrapped to keep
 * that shape rather than touching every consumer.
 */
export interface IconAsset {
  src: string;
}

const asIcon = (src: string): IconAsset => ({ src });

export const ArrowDownIcon = asIcon(arrowDown);
export const ArrowRightIcon = asIcon(arrowRight);
export const ChatIcon = asIcon(chat);
export const ConferencesIcon = asIcon(conferences);
export const DashboardIcon = asIcon(dashboard);
export const DebugIcon = asIcon(debug);
export const EyeIcon = asIcon(eye);
export const FileIcon = asIcon(file);
export const Globe = asIcon(globe);
export const HomeIcon = asIcon(home);
export const HonorariumIcon = asIcon(honorarium);
export const LFLogo = asIcon(logo);
export const MagnifyingGlassIcon = asIcon(magnifyingGlass);
export const ObserveIcon = asIcon(observe);
export const PdfIcon = asIcon(pdf);
export const ReferralIcon = asIcon(referral);
export const FacebookIcon = asIcon(facebook);
export const InstagramIcon = asIcon(instagram);
export const TwitterIcon = asIcon(twitter);
export const TaxIcon = asIcon(tax);
export const TrashIcon = asIcon(trash);
export const WarningIcon = asIcon(warning);

export { ExternalLinkIcon, PhoneArrowUpRightIcon, PrinterIcon };
